import { type FC, useState, useCallback } from 'react';
import { graphql, useFragment } from 'react-relay';
import { orderFeedbackEvent } from '../../tracking/orderFeedbackTracking';

// components
import { Link } from 'dibs-elements/exports/Link';
import { FormattedMessage } from 'dibs-react-intl';
import { SellerReviewsModalAsync } from 'dibs-seller-reviews-modal/exports/SellerReviewsModalAsync';

// styles
import styles from './PdpSharedSellerDetailsFeedback.scss';

// types
import { type PdpSharedSellerDetailsFeedback_seller$key as Seller } from './__generated__/PdpSharedSellerDetailsFeedback_seller.graphql';

const sellerFragment = graphql`
    fragment PdpSharedSellerDetailsFeedback_seller on Seller {
        serviceId
        orderFeedbackPdp {
            metadata {
                aggregatedFeedback {
                    publicNoteTotalResults
                }
            }
            edges {
                node {
                    serviceId
                }
            }
        }
    }
`;
export const PdpSharedSellerDetailsFeedback: FC<{
    seller: Seller;
    isMobile: boolean;
}> = ({ seller: sellerRef, isMobile }) => {
    const seller = useFragment(sellerFragment, sellerRef);
    const { orderFeedbackPdp: reviews, serviceId } = seller || {};
    const numberOfReviews = reviews?.metadata?.aggregatedFeedback?.publicNoteTotalResults;
    const [isReviewsModalOpen, setIsReviewModalOpen] = useState(false);

    const openModal = useCallback(() => {
        orderFeedbackEvent({
            action: 'seller reviews expanded',
            label: 'pdp - seller details',
        });
        setIsReviewModalOpen(true);
    }, []);

    const onCloseModal = useCallback(() => {
        setIsReviewModalOpen(false);
    }, []);

    if (!numberOfReviews) {
        return null;
    }

    return (
        <>
            <Link
                onClick={openModal}
                className={styles.reviewsLink}
                dataTn="order-feedback-modal-trigger"
            >
                <FormattedMessage
                    id="PdpSharedSellerDetailsFeedback.seeReviews"
                    defaultMessage="{numberOfReviews, plural, one {# Review} other {# Reviews}}"
                    values={{ numberOfReviews }}
                />
            </Link>

            <SellerReviewsModalAsync
                isOpen={isReviewsModalOpen}
                onClose={onCloseModal}
                sellerId={serviceId}
                isMobileScrollContainer={isMobile}
            />
        </>
    );
};
